export default "__VITE_ASSET__DKWWPFmd__"